import { Expose } from 'class-transformer';

export class LocationModel {
  @Expose({ name: 'id' })
  id: number;
  @Expose({ name: 'name' })
  name: string;
  @Expose({ name: 'code' })
  code: string;
  @Expose({ name: 'address_id' })
  addressId: number;
  @Expose({ name: 'speed_gate_url' })
  speedGateUrl: string;
  @Expose({ name: 'security_group_id' })
  securityGroupId: number;
  @Expose({ name: 'lpr_type' })
  lprType: string;
  @Expose({ name: 'support_id' })
  supportId: number;
  @Expose({ name: 'priority_site_id' })
  prioritySiteId: string;
}
